<template>
  <div>
    <div class="paygrpsDiv">
      <div class="paygrp">
        <span>
          <b>New Joinees</b>
        </span>
        <div class="paygrps-info">
          <b>{{ countObj.totalNewJoineese }}</b>
          / {{countObj.totalEmployees}}
        </div>
      </div>
      <div class="alignPaygrp">
        <span>Paygroups Selected</span>
        <br />
        <div class="paygrps-info">
          <b>{{countObj.payGroupsSelected}}</b>
          / {{countObj.totalPayGroups}}
        </div>
      </div>
      <div class="alignPaygrp">
        <span>Total Employees</span>
        <br />
        <div class="paygrps-info">
          <b>{{countObj.totalEmployeesSelected}}</b>
          / {{countObj.totalEmployees}}
        </div>
      </div>
      <div class="alignPaygrp">
        <span>Eligible Employees</span>
        <br />
        <div class="paygrps-info">
          <b>{{countObj.eligibleEmployeesSelected}}</b>
          / {{countObj.totalEmployees}}
        </div>
      </div>
    </div>
    <div class="d-payroll__group">
      <div class="d-heading2 d-marginBottom d-flexbox">Add New Joinees</div>
    </div>
    <add-employee></add-employee>
    <br />
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import addEmployee from "@/modules/onboarding/views/pages/le-level/employees/EditEmployee.vue";
export default {
  name: "Joining",
  components: { addEmployee },
  data() {
    return {
      lockList: "",
      countObj: {
        payGroupsSelected: 0,
        totalEmployeesSelected: 0,
        eligibleEmployeesSelected: 0,

        totalNewJoineese: 0,
        totalPayGroups: 0,
        totalEmployees: 0,
        totalEligibleEmployees: 0
      }
    };
  },
  activated() {
    this.fetchPaygroupsUpdatedData();
    this.setData();
  },

  mounted() {
    this.fetchPaygroupsUpdatedData();
    this.setData();
  },

  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState({
      selectedPayGroupsData: state => state.payroll.paygroups.data,
      payGroupsData: state => state.payroll.paygroups.payGroups,
      payrollMonth: state => state.payroll.runpayroll.payrollMonth,
      payrollYear: state => state.payroll.runpayroll.payrollYear
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    }
  },
  methods: {
    ...mapActions({
      act_fetch_paygroups_updated_data: "payroll/paygroups/fetchAll"
    }),
    /** To fetch the paygroups data */
    async fetchPaygroupsUpdatedData() {
      try {
        let res = await this.act_fetch_paygroups_updated_data({
          le_id: this.le_id,
          processing_payroll_month: this.getSelectedMonthEnumByName(
            this.payrollMonth
          ),
          financial_year: this.payrollYear
        });
        if (res.status) {
          this.setData();
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to return the selected month enum */
    getSelectedMonthEnumByName(selectedMonth) {
      try {
        let selectedMonthEnum = "";
        switch (selectedMonth) {
          case "January":
            selectedMonthEnum = "jan";
            break;
          case "February":
            selectedMonthEnum = "feb";
            break;
          case "March":
            selectedMonthEnum = "mar";
            break;
          case "April":
            selectedMonthEnum = "apr";
            break;
          case "May":
            selectedMonthEnum = "may";
            break;
          case "June":
            selectedMonthEnum = "jun";
            break;
          case "July":
            selectedMonthEnum = "jul";
            break;
          case "August":
            selectedMonthEnum = "aug";
            break;
          case "September":
            selectedMonthEnum = "sep";
            break;
          case "October":
            selectedMonthEnum = "oct";
            break;
          case "November":
            selectedMonthEnum = "nov";
            break;
          case "December":
            selectedMonthEnum = "dec"; // PL-2264
            break;

          default:
            break;
        }
        return selectedMonthEnum; // Enum type - values :  ['jan', 'feb','mar', 'apr','may', 'jun','jul', 'aug','sep', 'oct','nov', 'dec']
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** To lock/unlock the 'Next' button */
    locklist(ee) {
      if (ee) {
        this.lockList = "Yes";
      } else {
        this.lockList = "No";
      }
    },
    /** Function to set the counts of different elements in UI */
    setData() {
      try {
        let payGroupsData = this.payGroupsData[this.le_id];
        let selectedPayGroupsData = this.selectedPayGroupsData[this.le_id];
        if (payGroupsData && payGroupsData.length) {
          this.countObj.totalPayGroups = payGroupsData.length;

          let totalEmployees = 0;
          let totalEligibleEmployees = 0;

          payGroupsData.forEach(item => {
            totalEmployees =
              totalEmployees + (item.totalEmployess ? item.totalEmployess : 0);
            totalEligibleEmployees =
              totalEligibleEmployees +
              (item.eligibleEmployees ? item.eligibleEmployees : 0);
          });

          this.countObj.totalEmployees = totalEmployees;
          this.countObj.totalEligibleEmployees = totalEligibleEmployees;
        }
        if (selectedPayGroupsData && selectedPayGroupsData.length) {
          this.countObj.payGroupsSelected = selectedPayGroupsData.length;

          let totalEmployeesSelected = 0;
          let eligibleEmployeesSelected = 0;
          let totalNewJoineese = 0;

          selectedPayGroupsData.forEach(item => {
            totalEmployeesSelected =
              totalEmployeesSelected +
              (item.totalEmployess ? item.totalEmployess : 0);
            eligibleEmployeesSelected =
              eligibleEmployeesSelected +
              (item.eligibleEmployees ? item.eligibleEmployees : 0);
            totalNewJoineese =
              totalNewJoineese + (item.newJoineese ? item.newJoineese : 0);
          });

          this.countObj.totalEmployeesSelected = totalEmployeesSelected;
          this.countObj.eligibleEmployeesSelected = eligibleEmployeesSelected;
          this.countObj.totalNewJoineese = totalNewJoineese;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common
@import "@/scss/dashboard/content/_section.scss"; // Content Section

.paygrpsDiv {
  display: flex;
  cursor: pointer;
  padding: 40px 0px;

  span {
    color: #646464;
    font-size: 16px;
  }
  > :nth-child(n) {
    margin-right: 64px;
  }
  > :last-child {
    margin-right: 0px;
  }
}
.paygrps-info {
  color: #646464;
  cursor: pointer;
  text-align: center;
  margin-top: 5px;

  b {
    font-size: 24px;
    font-weight: 500;
  }
}
.paygrp {
  background: #fbfbfb;
  width: 220px;
  height: 85px;
  border-radius: 2px;
  border: solid 1px #37c6c0;
  padding: 20px;
  text-align: center;
}
.alignPaygrp {
  padding: 20px;
  text-align: center;
}
.d-marginBottom {
  margin-bottom: 7px;
}
.line {
  border-bottom: 1px solid #c8c8c8;
  width: 100%;
  margin-bottom: 20px;
}
.label {
  font-size: 12px;
  font-weight: 300;
  margin-bottom: 8px;
  color: #6e6e6e;
}
.lock-list {
  margin-top: 2%;
  display: flex;
  span {
    margin-top: 2px;
  }
}
</style>
